import React, { useEffect, useState } from 'react';
import EcranPassage from './connexion/EcranPassage';
import { lireEcrans, momentPour, segments, heureDe } from './connexion/contenusEcrans';

/**
 * Écran d'accueil du kiosque de pointage : la même école au soleil que
 * l'administration, sans nom de personne (le compte est celui du kiosque).
 * Ancienne version : components/dump/KiosqueWelcomeScreen-V1-avant-refonte.jsx
 */
const KiosqueWelcomeScreen = () => {
  const [maintenant, setMaintenant] = useState(new Date());
  const [ecrans] = useState(lireEcrans);
  const [moment] = useState(() => momentPour(ecrans.horaires));

  useEffect(() => {
    const timer = setInterval(() => setMaintenant(new Date()), 1000);

    const timeout = setTimeout(() => {
      window.location.href = '/kiosque-pointage';
    }, 3000);

    return () => {
      clearInterval(timer);
      clearTimeout(timeout);
    };
  }, []);

  const valeurs = { heure: heureDe(maintenant) };
  const textes = ecrans.accueil_kiosque;

  return (
    <EcranPassage
      sens="arrivee"
      moment={moment}
      titre={segments(textes[moment], valeurs, [])}
      ligne={[{ texte: textes.titre, gras: true }]}
      phrase={segments(ecrans.accueil.heure, valeurs, [])}
      icone="horloge"
      duree={3}
    />
  );
};

export default KiosqueWelcomeScreen;
